import { FC, useMemo } from 'react';

import { REGEXES } from 'modules/authentication/presentation/constants';
import { ICONS } from 'shared/presentation/constants';
import { useLocale, useTheme } from 'shared/presentation/contexts';

import * as S from './styles';

interface IPasswordRules {
  password: string;
}

const IconX = ICONS.X;
const IconCheck = ICONS.CHECK;

export const PasswordRules: FC<IPasswordRules> = ({ password }) => {
  const { theme } = useTheme();
  const { t } = useLocale('authentication');

  const rules = useMemo(
    () => [
      {
        regex: REGEXES.PASSWORD.AT_LEAST_8_CHARACTERS,
        label: t('It must contain at least 8 characters'),
      },
      {
        regex: REGEXES.PASSWORD.AT_LEAST_ONE_LOWER_CASE_LETTER,
        label: t('It must contain at least one lower case letter'),
      },
      {
        regex: REGEXES.PASSWORD.AT_LEAST_ONE_UPPER_CASE_LETTER,
        label: t('It must contain at least one upper case letter'),
      },
      {
        regex: REGEXES.PASSWORD.AT_LEAST_ONE_NUMBER,
        label: t('It must contain at least one number'),
      },
      {
        regex: REGEXES.PASSWORD.AT_LEAST_ONE_SPECIAL_CHARACTER,
        label: t('It must contain at least one special character'),
      },
    ],
    [t],
  );

  return (
    <S.Container>
      {rules.map(rule => (
        <S.Rule key={rule.label}>
          {rule.regex.test(password) ? (
            <IconCheck color={theme.palette.primary.main} />
          ) : (
            <IconX />
          )}

          <span>{rule.label}</span>
        </S.Rule>
      ))}
    </S.Container>
  );
};
